import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Img, Text } from "components";
import { AddToCart } from "popups/AddToCart";
import { RepeatOrder } from "popups/RepeatOrder";
import { useTranslation } from "react-i18next";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux"; // ✅ useSelector add kiya
import { changeLoader } from "../../redux/reducers/loader";
import { setSnackbar } from "../../redux/reducers/snackbar";
import * as APIS from "../../utils/helper/Enum";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import styled from "styled-components";
import { changeTrigger } from "redux/reducers/trigger";
import * as CUSTOM from "../../utils/helper/custom";
import { getAuth } from "../../redux/reducers/loginData"; // ✅ auth selector
import { useAppFont } from "utils/helper/useAppFont";

// const useStyles = makeStyles((theme) => ({
//   customTooltip: {
//     backgroundColor: "white", // Change the background color here
//     color: "black", // Change the font color here
//     fontSize: "16px", // You can adjust the font size here if needed
//     boxShadow: "10px 14px 16px rgba(0, 0, 0, 0.1)",
//     padding: "20px",
//   },
// }));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    margin: 0,
    marginLeft: "-20px",
    padding: 0,
    boxShadow: "0 0 25px -5px rgb(0 0 0 / 0.1), 0 0 10px -6px rgb(0 0 0 / 0.1)",
    ".MuiTooltip-arrow": {
      color: "#FFFFFF", // Arrow color
      width: "28px", // Arrow width
      height: "16px", // Arrow height
      top: "-7px", // Position where arrow is pointing
      left: "12px!important", // Position where arrow is pointing
    },
  },
}));

const ProductCartCardBox = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useSelector(getAuth);

  const [AddToCartOpen, setAddToCartOpen] = React.useState(false);
  const [uomData, setUomData] = React.useState({});
  const [main_product_id, setPpoductId] = React.useState({});
  const [cartData, setCartData] = React.useState([]);
  const [RepeatOrderOpen, setRepeatOrderOpen] = React.useState(false);
  const [openTooltip, setOpenTooltip] = React.useState({
    status: false,
    id: 0,
  });
  const [incrementQty, setIncrementQty] = React.useState({
    id: 0,
    qty: 0,
    product_id: 0,
    uomData: {},
  });

  const [isWishlisted, setIsWishlisted] = React.useState(false);
  const [wishlistLoading, setWishlistLoading] = React.useState(false);
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  useEffect(() => {
    if (typeof props?.isWishlist !== "undefined") {
      setIsWishlisted(props?.isWishlist);
    }
  }, [props?.isWishlist]);

  const toggleWishlist = async (e) => {
    e.stopPropagation();

    if (!auth?.id) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: "Please login to proceed",
          snackbarState: "error",
        })
      );
      return;
    }

    if (typeof props.onWishlistToggle === "function") {
      props.onWishlistToggle(main_product_id);
      return;
    }

    if (wishlistLoading) return;

    try {
      setWishlistLoading(true);

      let response = await globalRequest(
        APIS?.WISHLIST?.ADD_TO_WISHLIST,
        "post",
        { productId: main_product_id },
        {},
        true
      );
      response = response?.data;

      if (response?.status === "SUCCESS") {
        setIsWishlisted(response?.data?.isWishlist);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    } finally {
      setWishlistLoading(false);
    }
  };

  const handelAddToCart = () => {
    CUSTOM.trackAddToCart({
      id: props?.productId,
      name: props?.productName,
      price: props?.uomData?.sellingPrice,
      quantity: props?.quantity,
    });
    setAddToCartOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  const CheckUomExistInCart = () => {
    if (cartData.length > 0 && Object.keys(uomData).length > 0) {
      let data = cartData.filter(
        (items) => items?.productId == main_product_id
      );
      if (data.length > 0) {
        let quantityData = {
          ...data[data.length - 1],
          quantity: data.reduce((total, item) => {
            return total + item.quantity;
          }, 0),
        };
        return quantityData;
      }
    }
  };

  /**
  * get modifiers
  */
  const getModifiers = async (id) => {
    try {
      let response = await globalRequest(
        `${APIS?.PRODUCTS?.GET_MODIFIER_BY_UOM_ID}/${id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        return { status: "success", data: response?.data };
      } else {
        return { status: "success", data: [] };
      }
    } catch (e) {
      return { status: "error", message: e?.message };
    }
  };

  /**
  * get product uoms
  */
  const getProductUoms = async (id) => {
    try {
      let response = await globalRequest(
        `${APIS?.PRODUCTS?.GET_UOMS_BY_PRODUCT_ID}/${id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        return { status: "success", data: response?.data };
      } else {
        return { status: "success", data: [] };
      }
    } catch (e) {
      return { status: "error", message: e?.message };
    }
  };

  /**
   * Decreament cart item quantity
   */
  const decrementCount = async (id, qtyCount, type = "subtract") => {
    try {
      dispatch(changeLoader(true));
      let inputData = {
        cart_item_id: id,
        qty: type == "subtract" ? Number(qtyCount) - 1 : Number(qtyCount) + 1,
        gaData: CUSTOM.getGACookieValues(),
      };
      let response = await globalRequest(
        APIS?.CART?.UPDATE_QTY,
        "put",
        inputData,
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(changeTrigger("fetchCartCount"));
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  const changeQuy = (id, type = "subtract") => {
    if (cartData.length > 0 && Object.keys(uomData).length > 0) {
      let data = cartData.filter((items) => items?.productId == id);
      if (type == "add") {
        let lastids = data[data.length - 1];
        setIncrementQty({
          id: lastids?.id,
          qty: Number(lastids?.quantity),
          product_id: lastids?.productId,
          uomData: lastids,
        });
      } else {
        if (data.length > 1) {
          setOpenTooltip({ status: true, id: id });
        } else {
          decrementCount(data?.[0]?.id, data?.[0]?.quantity, type);
          setOpenTooltip({ status: false, id: 0 });
        }
      }
    }
  };

  /**
   *  check product data
   * */
  const checkProductData = async (id) => {
    let uomData = await getProductUoms(main_product_id);
    if (uomData?.status == "error") {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: uomData?.message,
          snackbarState: "error",
        })
      );
      return "error";
    }
    if (uomData?.data?.length <= 1) {
      let modifierData = await getModifiers(uomData?.data?.[0]?.id);
      if (modifierData?.status == "error") {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: modifierData?.message,
            snackbarState: "error",
          })
        );
        return "error";
      }
      if (modifierData?.data?.length == 0) {
        if (cartData.length > 0 && Object.keys(uomData).length > 0) {
          let data = cartData.filter((items) => items?.productId == id);
          let lastids = data[data.length - 1];
          decrementCount(lastids?.id, Number(lastids?.quantity), "add");
          return "incremented";
        }
      }
    }
    return "open_popup";
  }

  useEffect(() => {
    if (openTooltip?.status) {
      setTimeout(() => {
        setOpenTooltip({ status: false, id: 0 });
      }, 2500);
    }
  }, [openTooltip?.status]);

  useEffect(() => {
    if (typeof props?.uomData !== "undefined") {
      setUomData(props?.uomData);
    }
  }, [props]);

  useEffect(() => {
    if (typeof props?.productId !== "undefined") {
      setPpoductId(props?.productId);
    }
  }, [props]);

  useEffect(() => {
    if (typeof props?.cartData !== "undefined") {
      setCartData(props?.cartData);
    }
  }, [props]);

  useEffect(() => {
    if (RepeatOrderOpen == "incQty") {
      setRepeatOrderOpen(false);
      decrementCount(incrementQty?.id, incrementQty?.qty, "add");
    }
    if (RepeatOrderOpen == "addNewProduct") {
      setRepeatOrderOpen(false);
      setAddToCartOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RepeatOrderOpen]);

  // useEffect(() => {
  //   if (props?.discountedPrice?.props?.children[0]){
  //     let cur = props?.discountedPrice?.props?.children[0];
  //     cur = '';
  //     props?.discountedPrice?.props?.children[0] = cur;
  //   }
  // })

  const getCartProductData = () => {
    if (!cartData || cartData.length === 0) return null;
    const items = cartData.filter((item) => item.productId === main_product_id);
    if (items.length === 0) return null;
    return {
      quantity: items.reduce((sum, i) => sum + Number(i.quantity), 0),
      lastItem: items[items.length - 1],
    };
  };

  const cartProduct = getCartProductData();

  return (
    <>
      <div>
        <div
          className="
            relative flex flex-col w-[280px] sm:w-[200px]
            flex-shrink-0 p-4 gap-6 rounded-[20px]
            border border-[#F7F7F7] bg-[#FFFFFF]
          "
        >
          <div
            className="relative w-full h-[180px] sm:h-[140px] md:h-[180px] rounded-xl overflow-hidden cursor-pointer"
            onClick={() => navigate(`/productdetail/${props?.slug}`)}
          >
            <Img
              src={props?.productimage}
              alt="product"
              className="w-full h-full object-cover rounded-xl transition-transform duration-500 hover:scale-105"
            />

            {Number(props?.isBestSeller) === 1 && (
              <div className="absolute top-3 right-3 bg-[#FFFFFF] sm:top-5 sm:right-5 bg-white px-3 py-1 sm:py-0 sm:px-2 rounded-full text-xs sm:text-[8px] font-medium text-[#E6A400] shadow">
                Popular
              </div>
            )}

            {Number(props?.isRecommended) === 1 && (
              <div className="absolute top-3 right-3 sm:top-5 sm:right-5 px-3 py-1 sm:px-2 sm:py-0 rounded-full text-xs sm:text-[8px] font-medium shadow bg-[#FFFFFF]">
                <span className="bg-[linear-gradient(90deg,#30B5E8_0%,#1B6582_100%)] bg-clip-text text-transparent">
                  Recommended
                </span>
              </div>
            )}

            {props?.productRatingBox && (
              <div className="absolute bottom-3 bg-[#FFFFFF] right-3 px-2 py-1 sm:px-4 rounded-full flex items-center gap-1 text-xs shadow">
                <Img src="/images/img_star.svg" alt="star" className="h-4 w-4" />
                <span>{props?.productrating}</span>
              </div>
            )}
          </div>

          <Text
            className={`text-base sm:text-xs font-normal text-[#771237] cursor-pointer line-clamp-1 ${interClass} font-[16px] sm:font-[12px] px-2`}
            onClick={() => navigate(`/productdetail/${props?.slug}`)}
          >
            {props?.productName}
          </Text>

          <div className="flex items-center gap-2 px-2 sm:px-4">
            <span className="flex items-center gap-[10px] text-xl font-semibold sm:text-xs text-[#771237]">
              <span className="flex w-[20px] h-[20px] py-[1px] justify-center items-center">
                <img
                  src="/images/Groupsar.svg"
                  alt="icon"
                  className="w-full h-full object-contain"
                />
              </span>
              <span>{props?.discountedPrice}</span>
            </span>

            {props?.originalPrice && (
              <span className="text-sm sm:text-xs text-[#9E9E9E] line-through">
                {props?.originalPrice}
              </span>
            )}
          </div>

          <div className="flex flex-row gap-2">
            {/* ADD TO CART */}
            {!cartProduct && (
              <Button
                className={`
                  w-[75%] h-12 sm:h-8 rounded-full border border-[#E6E6E6]
                  bg-[FFFFFF] text-[#1A1A1A] font-medium sm:text-xs text-sm
                  ${interClass} transition-all duration-300
                  hover:text-[#771237] hover:border-[#771237] btn-spread
                `}
                onClick={() => {
                  handelAddToCart();
                }}
              >
                {t("addToCart")}
              </Button>
            )}

            {/* QUANTITY CONTROLS */}
            {cartProduct && (
              <div className="w-[75%] h-12 rounded-full text-[#FFFFFF] bg-[#771237] flex items-center justify-between px-6 text-white sm:h-auto">
                <button
                  onClick={() => {
                    changeQuy(main_product_id, "subtract");
                    CUSTOM.trackRemoveFromCart({
                      id: props?.productId,
                      name: props?.productName,
                      quantity: cartProduct.quantity,
                    });
                  }}
                  className={`text-xl h-[24px] w-[24px] ${interClass} flex items-center justify-center sm:h-6 sm:w-6 text-[#FFFFFF] sm:text-[14px]`}
                >
                  −
                </button>

                <span className={`font-medium ${interClass} text-xl h-[24px] w-[24px] flex items-center justify-center sm:h-6 sm:w-6 text-[#FFFFFF] sm:text-[14px] sm:h-auto`}>
                  {cartProduct.quantity}
                </span>

                <button
                  onClick={async () => {
                    let data = await checkProductData(main_product_id);
                    if (data !== "open_popup") return;
                    changeQuy(main_product_id, "add");
                    setRepeatOrderOpen(true);
                  }}
                  className={`text-xl h-[24px] w-[24px] sm:text-[14px] ${interClass} flex items-center justify-center sm:h-6 sm:w-6 text-[#FFFFFF]`}
                >
                  +
                </button>
              </div>
            )}

            {/* WISHLIST HEART BUTTON */}
            <button
              onClick={toggleWishlist}
              disabled={wishlistLoading}
              className={`
                w-12 h-12 sm:w-8 sm:h-8 rounded-full border
                flex items-center justify-center btn-spread transition
                ${isWishlisted
                  ? "border-[#771237] bg-[#fff0f4]"
                  : "border-[#E6E6E6] bg-[white]"
                }
                ${wishlistLoading ? "opacity-50 cursor-not-allowed" : ""}
              `}
            >
              {isWishlisted && (
                <Img
                  src="/images/heartIconFilled.svg"
                  alt="heart-filled"
                  className="w-6 h-6 sm:w-4 sm:h-4"
                />
              )}

              {!isWishlisted && (
                <Img
                  src="/images/heartIcon.svg"
                  alt="heart"
                  className="w-6 h-6 sm:w-4 sm:h-4"
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {AddToCartOpen === true ? (
        <AddToCart
          closepopup={setAddToCartOpen}
          productId={props?.productId}
          productName={props.productName}
          price={props?.uomData?.sellingPrice}
          quantity={props?.quantity}
        />
      ) : null}

      {RepeatOrderOpen === true ? (
        <RepeatOrder
          closepopup={setRepeatOrderOpen}
          cartIds={incrementQty}
          cartData={cartData}
        />
      ) : null}
    </>
  );
};

ProductCartCardBox.defaultProps = {
  productimage: "",
  productSortingBox: "",
  productsorting: "",
  productRatingBox: "",
  productrating: "",
  productName: "",
  discountedPrice: "",
  originalPrice: "",
  buttonAddToCart: "",
  buttonAddRemoveProduct: "",
  isWishlist: false,
};

export default ProductCartCardBox;
